// frontend/src/components/games/tetris/TetrisBoard.tsx

import { ActivePiece, Board } from '../../../hooks/games/useTetrisGame';
import { TETROMINO_COLORS } from './tetrominoes';

interface TetrisBoardProps {
  board: Board;
  current: ActivePiece;
}

export function TetrisBoard({ board, current }: TetrisBoardProps) {
  const height = board.length;
  const width = board[0]?.length ?? 0;

  const overlay: (string | null)[][] = board.map((row) => [...row]);
  for (let r = 0; r < current.shape.length; r++) {
    for (let c = 0; c < current.shape[r].length; c++) {
      if (!current.shape[r][c]) continue;
      const y = current.y + r;
      const x = current.x + c;
      if (y >= 0 && y < height && x >= 0 && x < width) {
        overlay[y][x] = current.type;
      }
    }
  }

  return (
    <div
      className="tetris-board"
      style={{ gridTemplateColumns: `repeat(${width}, 1fr)`, gridTemplateRows: `repeat(${height}, 1fr)` }}
    >
      {overlay.map((row, r) =>
        row.map((cell, c) => (
          <div
            key={`${r}-${c}`}
            className={`tetris-cell ${cell ? 'filled' : ''}`}
            style={cell ? { background: TETROMINO_COLORS[cell as keyof typeof TETROMINO_COLORS] } : undefined}
          />
        ))
      )}
    </div>
  );
}
